// lib/db/migrations.ts — Schema versioning and legacy data migration placeholder

/**
 * Legacy data migration placeholder.
 * 
 * TODO: Fill in the transformation logic when the legacy localStorage structure is shared.
 * 
 * Current behaviour:
 * - Detects if there is any data in localStorage under known sortednow keys
 * - Logs a warning if found, but does NOT delete or modify legacy data
 * - The actual import logic is stubbed and commented out
 */
export async function migrateLegacyData(userId: string): Promise<void> {
  const LEGACY_KEYS = [
    'sortednow_data',
    'sortednow_encrypted',
    'sortednow_groups',
    'sinking_funds',
    'sorted_data',
  ];

  const foundKey = LEGACY_KEYS.find(k => localStorage.getItem(k) !== null);
  if (!foundKey) return;

  console.warn(
    `[Migration] Legacy data found in localStorage at key "${foundKey}" for user ${userId}. ` +
    'Migration logic pending — please share the legacy data structure.'
  );

}